import Vue from 'vue'
import { login, getInfo, logout } from '@/api/login'
import { ACCESS_TOKEN, USERID, RESETTAG, UTOKEN, UNAME } from '@/store/mutation-types'
import { welcome } from '@/utils/util'

const user = {
  state: {
    token: '',
    userid: 0,
    name: '',
    lang: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERID: (state, userid) => {
      state.userid = userid
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_LANG: (state, lang) => {
      state.lang = lang
    }
  },

  actions: {
    // 登录
    Login: function ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if (response.code === 0) {
            const result = response.data
            Vue.ls.set(ACCESS_TOKEN, result.session, 7 * 24 * 60 * 60 * 1000)
            const u = Vue.ls.get(USERID)
            if ((!u) || u !== result.user_id) {
              Vue.ls.set('NEWU', true, 7 * 24 * 60 * 60 * 1000)
            }
            Vue.ls.set(USERID, result.user_id, 7 * 24 * 60 * 60 * 1000)

            commit('SET_USERID', result.user_id)
            commit('SET_TOKEN', result.session)
            resolve()
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const result = response.data
          if (result.role && result.role.permissions.length > 0) {
            const role = result.role
            // role.permissions = result.role.permissions
            // role.permissions.map(per => {
            //   if (per.actionEntitySet != null && per.actionEntitySet.length > 0) {
            //     const action = per.actionEntitySet.map(action => { return action.action })
            //     per.actionList = action
            //   }
            // })
            role.permissionList = role.permissions.map(permission => { return permission.permissionId })
            commit('SET_ROLES', result.role)
            commit('SET_LANG', result.lang)
            Vue.ls.set('role', result.roleId)
            commit('SET_INFO', result)
            Vue.ls.set(UNAME, result.name)
            Vue.ls.set(UTOKEN, result.u_token)
            Vue.ls.set(RESETTAG, result.reset_tag)
          } else {
            reject(new Error('getInfo: roles must be a non-null array !'))
          }

          commit('SET_NAME', { name: result.name, welcome: welcome() })
          if (result.avatar && result.avatar.length > 0) {
            commit('SET_AVATAR', result.avatar)
          } else {
            if (result.sex === 0) {
              commit('SET_AVATAR', '/head_women.png')
            } else {
              commit('SET_AVATAR', '/head_men.png')
            }
          }

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        Vue.ls.remove(USERID)
        Vue.ls.remove(ACCESS_TOKEN)

        logout(state.token).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    }

  }
}

export default user
